import React, { useState } from 'react'
import styled from 'styled-components'

// Components
import LabelButton from './LabelButton'

interface IProps {
  caption: string
  content: React.ReactNode
  opened?: boolean
  amount?: number
  onClick?: () => void
  showNotification?: boolean
  color?: string
  hoverColor?: string
  className?: string
}

/**
 * A section that opens under its own header. The header is the shared
 * LabelButton; Fold adds the only two things it does not have — the open state
 * and the content that hangs off it.
 */
const Fold = ({
  caption,
  content,
  opened,
  onClick,
  amount,
  showNotification,
  color,
  hoverColor,
  className,
}: IProps) => {
  const [open, setOpen] = useState(opened)

  return (
    <div className={className}>
      <Header
        caption={caption}
        open={open}
        amount={amount}
        showNotification={showNotification}
        color={color}
        hoverColor={hoverColor}
        onClick={() => {
          setOpen(!open)
          onClick && onClick()
        }}
      />
      {open && content}
    </div>
  )
}

/* Spans the card it sits in, which is what sends the chevron to the far edge
   instead of leaving it against the label. */
const Header = styled(LabelButton)`
  width: 100%;
`

export default Fold
